export const PLATFORM_ICONS: Record<string, string> = {
  'Microsoft Entra': 'assets/media/integration/microsoft-entra.png',
  'Microsoft Azure':
    'https://developmentcontent.blob.core.windows.net/resources/cloud_infrastructure/Azure.png',
  'Microsoft Email Configuration': 'assets/media/integration/microsoft.png',
  'Google Email Configuration': 'assets/media/integration/google-workspace.png',
  // Identity & Productivity
  'Microsoft Entra ID': 'assets/media/integration/microsoft-entra.png',
  'Google Workspace': 'assets/media/integration/google-workspace.png',

  // Cloud Providers
  AWS: 'assets/media/integration/aws.png',
  'Amazon Web Services': 'assets/media/integration/aws.png',
  'Google Cloud': 'assets/media/integration/google-cloud.png',
  GCP: 'assets/media/integration/google-cloud.png',
  'Cloud Computing': 'assets/media/integration/google-cloud.png',
  'Google Cloud Platform (GCP)': 'assets/media/integration/google-cloud.png',

  // Asset Management / ITSM
  'Snipe-IT': 'assets/media/integration/snipe-it.png',
  'ManageEngine Asset Explorer':
    'assets/media/integration/manageengine-asset-explorer.png',
  Freshservice: 'assets/media/integration/freshservice.png',
  Spiceworks: 'assets/media/integration/spiceworks.png',
  'Asset Panda': 'assets/media/integration/asset-panda.png',
  'InvGate Asset Management': 'assets/media/integration/invgate.png',
  'InvGate Asset': 'assets/media/integration/invgate.png',

  // Default fallback
  default: 'assets/media/integration/default.svg',
};
